<template>
<div class="loader-wrap">
	<div class="backdrop"></div>
	<div class="loader">
		<div class="spinner large">
			<div class="spinner-wrapper">
				<div class="rotator">
					<div class="inner-spin"></div>
					<div class="inner-spin"></div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {}
</script>

<style scoped>
.loader-wrap {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 100000;
}
.loader {
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	opacity: 0.5;
}
.backdrop {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	opacity: 0.5;
}

.medium {
	transform: scale(1);
}

.large {
	margin-top: 4em;
	transform: scale(1.5);
}

.spinner-wrapper {
	position: relative;
	width: 4em;
	height: 4em;
	border-radius: 100%;
	left: calc(50% - 2em);
}

.spinner-wrapper::after {
	content: '';
	background: #fff;
	border-radius: 50%;
	width: 3em;
	height: 3em;
	position: absolute;
	top: 0.5em;
	left: 0.5em;
}

.rotator {
	position: relative;
	width: 4em;
	border-radius: 4em;
	overflow: hidden;
	animation: rotate 2000ms infinite linear;
}

.rotator:before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #3f51b5;
	border: 3px solid #fff;
	border-radius: 100%;
}

.inner-spin {
	background: #fff;
	height: 4em;
	width: 2em;
}

.inner-spin {
	animation: rotate-left 2500ms infinite cubic-bezier(0.445, 0.05, 0.55, 0.95);
	border-radius: 2em 0 0 2em;
	transform-origin: 2em 2em;
}

.inner-spin:last-child {
	animation: rotate-right 2500ms infinite cubic-bezier(0.445, 0.05, 0.55, 0.95);
	margin-top: -4em;
	border-radius: 0 2em 2em 0;
	float: right;
	transform-origin: 0 50%;
}

@keyframes rotate-left {
	60%,
	75%,
	100% {
		transform: rotate(360deg);
	}
}

@keyframes rotate {
	0% {
		transform: rotate(0);
	}
	100% {
		transform: rotate(360deg);
	}
}

@keyframes rotate-right {
	0%,
	25%,
	45% {
		transform: rotate(0);
	}

	100% {
		transform: rotate(360deg);
	}
}
</style>
